import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=37712970&scoped=true"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"
import style0 from "./Gift.vue?vue&type=style&index=0&id=37712970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37712970",
  null
  
)

export default component.exports